export class LanguageConstant {
  static readonly ENG = 'en';
  static readonly NO = 'no';
}
